import React from 'react'
import { createPortal } from "react-dom"
import modal from './Modal.module.scss'
import ModalOverlay from '../ModalOverlay/ModalOverlay'

const Modal = ({onClose, isRus}) => {

    const modalRoot = document.getElementById("modals");

    return createPortal (
        <ModalOverlay>
            <div className={modal.modal} onClick={evt => evt.stopPropagation()}>
                 <div className={modal.box_bg}>
                 <div className={modal.box}>    
                <h2 className={modal.title}>{ isRus  ? 'Спасибо за обращение' : 'Thank you for contacting us'}Спасибо за обращение</h2>
                <p className={modal.text}>{ isRus  ? 'Я свяжусь с Вами в ближайшее время' : 'I will contact you as soon as possible.'}</p>
                <button className={modal.button} type='button' onClick={onClose}>{ isRus  ? 'Вернуться на сайт' : 'Go back to the website'} </button>
            </div>
            </div>
            </div> 
        </ModalOverlay>
        ,modalRoot
    );
};

export default Modal